var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFMiconLearnmore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FMicon_learnmore",
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2513413,16.6520842 C31.5622516,16.6520842 17.2215185,30.9902368 17.2183291,48.6793263 C17.2151407,66.3684157 31.5507031,80.7117355 49.2397916,80.7181181 C66.9288802,80.7244964 81.2747862,66.3915221 81.2843629,48.702435 C81.2889571,40.2037478 77.91609,32.0515708 71.9082355,26.0404653 C65.9003809,20.0293597 57.7500298,16.6520842 49.2513413,16.6520842 L49.2513413,16.6520842 Z M49.5460173,73.7383409 C36.0541317,73.7383409 25.1167974,62.8010066 25.1167974,49.3091209 C25.1167974,35.8172353 36.0541317,24.8799009 49.5460173,24.8799009 C63.037903,24.8799009 73.9752373,35.8172353 73.9752373,49.3091209 C73.9752373,55.7881529 71.4014519,62.0018206 66.8200844,66.583188 C62.238717,71.1645555 56.0250493,73.7383409 49.5460173,73.7383409 L49.5460173,73.7383409 Z",
    id: "Shape",
    fill: "#173050",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#173050",
    strokeWidth: 1.22,
    cx: 49.3669005,
    cy: 49.3264548,
    r: 19.9975237
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#173050",
    fillRule: "nonzero",
    points: "44.1494016 44.6231944 0 47.957078 44.1494016 52.1403219"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#173050",
    fillRule: "nonzero",
    points: "52.868345 44.1494016 49.5402394 0 45.3569955 44.1494016"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#173050",
    fillRule: "nonzero",
    points: "45.3569955 53.2265786 48.6851011 97.3759802 52.868345 53.2265786"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#173050",
    fillRule: "nonzero",
    points: "53.8563764 44.6231944 98 47.957078 53.8563764 52.1403219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1126702,41.6648783 C45.1972153,41.6648783 42.0231118,44.8389817 42.0231118,48.7544366 C42.0231118,52.6698916 45.1972153,55.843995 49.1126702,55.843995 C53.0281252,55.843995 56.2022286,52.6698916 56.2022286,48.7544366 C56.2022286,44.8389817 53.0281252,41.6648783 49.1126702,41.6648783 L49.1126702,41.6648783 Z M49.1126702,50.9096162 C47.929537,50.9064271 46.9727035,49.9452866 46.9748245,48.762151 C46.9769527,47.5790153 47.9372319,46.6213175 49.120369,46.6223767 C50.3035061,46.6234378 51.2620718,47.582855 51.2620718,48.7659926 C51.2557061,49.9476254 50.2943159,50.9012624 49.1126702,50.8980603 L49.1126702,50.9096162 Z",
    id: "Shape",
    fill: "#173050",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.2587701,
    y1: 32.0561288,
    x2: 44.7156418,
    y2: 45.1721007,
    id: "Path",
    stroke: "#173050",
    strokeWidth: 1.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.4172513,
    y1: 54.208832,
    x2: 66.868345,
    y2: 67.3305819,
    id: "Path",
    stroke: "#173050",
    strokeWidth: 1.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.868345,
    y1: 31.2356583,
    x2: 53.8563764,
    y2: 44.6231944,
    id: "Path",
    stroke: "#173050",
    strokeWidth: 1.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44.8485349,
    y1: 53.919934,
    x2: 31.5938919,
    y2: 67.5443665,
    id: "Path",
    stroke: "#173050",
    strokeWidth: 1.22
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFMiconLearnmore);
export default __webpack_public_path__ + "static/media/FMicon_learnmore.99b0247b298222e7ec48c40aa6187e7d.svg";
export { ForwardRef as ReactComponent };